module.exports = __webpack_public_path__ + "assets/img/logo-ko.56307cac.png";